export interface GlossaryTerm {
  term: string;
  definition: string;
}

export const glossaryTerms: GlossaryTerm[] = [
  {
    term: "Allele",
    definition: "One of two or more versions of a genetic sequence at a particular location in the genome."
  },
  {
    term: "Benign Variant",
    definition: "A DNA change that does not cause disease or increase disease risk."
  },
  {
    term: "Chromosome",
    definition: "An organized package of DNA found in the nucleus of cells."
  },
  {
    term: "DNA Sequence",
    definition: "The precise ordering of the bases (A, T, G, C) in a DNA molecule."
  },
  {
    term: "Exome",
    definition: "The part of the genome formed by exons, the sequences which code for proteins."
  },
  {
    term: "Gene",
    definition: "A segment of DNA that codes for a specific protein or functional RNA molecule."
  },
  {
    term: "Genome",
    definition: "The complete set of genetic information in an organism."
  },
  {
    term: "Genotype",
    definition: "The genetic makeup of an organism or cell for a specific characteristic."
  },
  {
    term: "Heterozygous",
    definition: "Having two different alleles of a gene, one inherited from each parent."
  },
  {
    term: "Homozygous",
    definition: "Having two identical alleles of a gene, one inherited from each parent."
  },
  {
    term: "Mutation",
    definition: "A permanent change in the DNA sequence that may affect gene function."
  },
  {
    term: "Pathogenic Variant",
    definition: "A genetic change that increases the risk of developing a disease or condition."
  },
  {
    term: "Phenotype",
    definition: "The observable physical characteristics of an organism resulting from its genotype."
  },
  {
    term: "SNP (Single Nucleotide Polymorphism)",
    definition: "A variation in a single DNA base pair that occurs at a specific position in the genome."
  },
  {
    term: "VUS (Variant of Uncertain Significance)",
    definition: "A genetic change where there is not enough evidence to classify it as either pathogenic or benign."
  },
  {
    term: "Variant",
    definition: "A difference in DNA sequence compared to a reference genome."
  },
  {
    term: "Zygosity",
    definition: "The degree to which the alleles for a trait are identical or different in an organism."
  }
]; 